var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row mt-4"},[_c('div',{staticClass:"col-md-8 offset-md-2"},[_c('div',{staticClass:"jumbotron text-center"},[(_vm.loadingFlipbase)?_c('div',[_c('loader')],1):_vm._e(),(!_vm.loadingFlipbase && _vm.id)?_c('div',{attrs:{"id":"video-player-element"}}):_vm._e()])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }